import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Group, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  addEveryoneToResourceGroup(
    request: Boundaries["addEveryoneToResourceGroup"]["request"],
  ): void;
}

function useAddEveryoneToResourceGroup(group: Identifiable<Group>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isAddEveryoneToResourceGroupRequestPending(group),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isAddEveryoneToResourceGroupRequestSuccess(group),
    ),
    isRequestFailure: useSelector(() =>
      selector.isAddEveryoneToResourceGroupRequestFailure(group),
    ),
    addEveryoneToResourceGroup: core.addEveryoneToResourceGroup,
  };
}

export { useAddEveryoneToResourceGroup };
